import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import SimpleLayout from './SimpleLayout';
import EventChangePages from '../components/event/EventChangePages';
import '../css/style.css';
import '../components/Home.css';
import { translate } from "react-i18next";


class EventCloneLayout extends Component {

    
    render() {
        const { t } = this.props;
        const { params } = this.props.match
        return (<SimpleLayout title={t("ereignisbearbeiten")} eventKey="3">
                <Alert variant="info">
                        {t("successEventCloned")}
                    </Alert>
            <EventChangePages preURL="events/invited" id={params.id} activeTab={"termin"}  />
        </SimpleLayout>)
    }

}


export default translate("translations")(EventCloneLayout);